/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { ScrollableDialogContent } from '../../Components/ScrollableDialogContent.js';

import { Dialog, DialogTitle, Box, IconButton } from '@mui/material';
import { addSource } from './SourceManagement.js'
import { IoClose } from 'react-icons/io5';
import { Button } from '@mui/material';

const AddURL = ({ loadSources, loadQuestions, generateOverallSummary, workbook, triggerAddURL, setTriggerAddURL }) => {

  const [loaded, setLoaded] = useState(false);
  var loaded_static = false;

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [url, setUrl] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setIsLoading(true);
  
    try {
      // debug should add to RAG?

      var source = await addSource(workbook.id, 'url', url);
      if (source['status'] === 200) {
        setSuccessMessage('URL ingested.');
        var cur_sources = await loadSources();
        generateOverallSummary(cur_sources)
        loadQuestions(cur_sources);
      } else {
        setErrorMessage(source['response']);
      }

    } catch (error) {
      console.error('Error fetching content:', error);
    } finally {
      setIsLoading(false);
    }
  };

  function openModal() {
    setIsOpen(true);
    setErrorMessage('');
    setSuccessMessage('');
    setUrl('');
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setTriggerAddURL(0);
    setIsOpen(false);
  }

  useEffect(() => {
    if (triggerAddURL) {
      if (triggerAddURL === 1) {
        openModal()
      }
    }
  }, [triggerAddURL]);

  useEffect(() => {

    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    }, [])

  return (
    <Dialog
      open={modalIsOpen}
      onClose={closeModal}
      maxWidth='lg'
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Box display={'flex'} justifyContent={'space-between'}>
            Ingest a Web URL
            <IconButton onClick={closeModal}>
              <IoClose />
            </IconButton>
        </Box>
      </DialogTitle>
      <ScrollableDialogContent modalIsOpen={modalIsOpen}>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="url">URL*</Label>
            <Input required="required" size="100" type="text" value={url} onChange={event => setUrl(event.target.value)} />
          </FormGroup>
          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
          <Button type="submit" disabled={isLoading} variant='contained'>
            {isLoading ? 'Loading...' : 'Submit'}
          </Button>
        </Form>
      </ScrollableDialogContent>
    </Dialog>
  );
}
export default AddURL;
